import { useState } from "react";
import { TextField, Button, Box, Typography, Alert } from "@mui/material"; // Import MUI components
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useNavigate } from "react-router-dom";
const Login = () => {
    const navigate = useNavigate();
    const signIn = useSignIn();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const handleLogin = async (e) => {
        e.preventDefault(); // Prevents page refresh
        setError(""); // Reset error message

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ username, password }),
                }
            );

            const data = await response.json();
            if (response.ok && data.token) {
                const success = signIn({
                    auth: {
                        token: data.token,
                        type: "Bearer",
                    },
                    userState: data.user,
                });

                if (success) {
                    navigate("/");
                } else {
                    setError("Failed to log in. Please try again.");
                }
            } else {
                setError(data.message || "Invalid credentials");
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            sx={{
                padding: "0",
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                border="1px solid black"
                sx={{
                    borderRadius: "4px",
                    boxShadow:
                        "rgba(9, 11, 17, 0.5) 0px 5px 15px 0px, rgba(19, 23, 32, 0.08) 0px 15px 35px -5px;",
                    padding: "5rem 1rem ",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: "rgba(255, 255, 255, 0.12)",
                }}
            >
                <Typography variant="h4" gutterBottom>
                    Login
                </Typography>
                <form
                    onSubmit={handleLogin}
                    style={{ width: "100%", maxWidth: "400px" }}
                >
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />

                    <TextField
                        label="Password"
                        variant="outlined"
                        fullWidth
                        type="password"
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    {error && (
                        <Alert severity="error" sx={{ margin: "1rem 0" }}>
                            {error}
                        </Alert>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        type="submit"
                        sx={{ marginTop: "1rem" }}
                    >
                        Login
                    </Button>
                </form>
            </Box>
        </Box>
    );
};

export default Login;
